// extracted by mini-css-extract-plugin
export default {"wrapper":"profile-main-section_wrapper__eM4Ph","tabs":"profile-main-section_tabs__kOAdf","tabsSticky":"profile-main-section_tabsSticky__6wWWX"};